import styled from '@emotion/styled';
import type {
  AlignItemsProps,
  BorderRadiusProps,
  GridAreaProps,
  GridColumnGapProps,
  GridGapProps,
  GridRowGapProps,
  GridTemplateColumnsProps,
  GridTemplateRowsProps,
  GridTemplatesAreasProps,
  JustifyContentProps,
  WidthProps,
} from 'styled-system';
import {
  alignItems,
  backgroundColor,
  borderRadius,
  compose,
  gridArea,
  gridColumnGap,
  gridGap,
  gridRowGap,
  gridTemplateAreas,
  gridTemplateColumns,
  gridTemplateRows,
  justifyContent,
  space,
  width,
} from 'styled-system';

import type { BackgroundColorProps, SpaceProps } from '../theme/system-types';
import { Flex } from './Flex';

export const CssGrid = styled.div<
  GridTemplateColumnsProps &
    GridTemplateRowsProps &
    GridTemplatesAreasProps &
    GridGapProps &
    GridColumnGapProps &
    GridRowGapProps &
    BackgroundColorProps &
    SpaceProps &
    AlignItemsProps &
    JustifyContentProps &
    BorderRadiusProps &
    WidthProps
>(
  {
    display: 'grid',
  },
  compose(
    gridTemplateColumns,
    gridTemplateRows,
    gridTemplateAreas,
    gridGap,
    gridColumnGap,
    gridRowGap,
    backgroundColor,
    space,
    alignItems,
    justifyContent,
    borderRadius,
    width
  )
);

export const CssGridItem = styled.div<GridAreaProps>({}, compose(gridArea));

export const CssGridFlexItem = Flex;
